import { useLayoutEffect, useEffect } from 'react';

// useLayoutEffect will show warning if used during ssr
// useIsomorphicEffect removes it by replacing useLayoutEffect with useEffect during ssr
var useIsomorphicEffect = typeof document !== 'undefined' ? useLayoutEffect : useEffect;

export { useIsomorphicEffect as default };
//# sourceMappingURL=useIsomorphicEffect.js.map
